import { BudgetLabelPhrases } from "../budget/budget.labels";

/** Single config object for the Low Activity report (nav, page title, export, etc.). */
export const SE_LOW_ACTIVITY_REPORT = {
    displayName: "Low Activity report",
    exportFileBasename: "low-activity-report",
} as const;

export const ENGAGEMENT_LABELS = {
    featureName: "Engagement Metrics",
    reportTitle: "Engagement Reports",
    idCardsTitle: "ID Cards",
    layoutsTitle: "Layouts",
    configTitle: "Engagement Configuration",
    activityTypesTitle: "Activity Types",
    badgesTitle: "Badges",
    myActivityTitle: "My Activity",
    badgeEarnedToast: "Badge Earned!",
    secretBadgeEarnedToast: "You discovered a secret badge!",
    undiscoveredBadges: "Undiscovered Badges",
    badgeShowcaseTitle: "Badge showcase",
    badgeLockedHint: "Locked — keep going!",
    badgeEarnedHint: "Earned",
    noBadgesYet: "No badges yet",
} as const;

export const ACTIVITY_TYPE_LABELS: Record<string, string> = {
    LOGIN: "Login",
    EVENT_REGISTER: "Event Registration",
    ORG_MEMBERSHIP: "Organization Membership",
    FORM_SUBMIT: "Form Submission",
    EVENT_CREATE: "Event Creation",
    CHAT_OPEN: "Opened Chat",
    SERVICE_HOURS_SUBMIT: "Service Hours Submission",
    BUDGET_PLAN_SUBMIT: BudgetLabelPhrases.budgetPlanSubmitActivity,
    NEWS_ARTICLE_READ: "News Article Read",
    NEWS_ARTICLE_CREATE: "News Article Created",
    EVENT_SEARCH: "Event Search",
    EVENT_DETAILS_VIEW: "Event Details View",
    ATTENDANCE_CHECKIN: "Attendance Check-In",
    PROFILE_UPDATE: "Profile Update",
    ORG_PAGE_VIEW: "Organization Page View",
} as const;

/** Convert a SNAKE_CASE key to "Title Case" (e.g. GIVE_BACK -> "Give Back"). */
export function humanizeSnakeCase(key: string): string {
    return key
        .split("_")
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join(" ");
}

/** Resolve an activity type key to a human-readable label. */
export function activityLabel(key: string): string {
    return ACTIVITY_TYPE_LABELS[key] ?? humanizeSnakeCase(key);
}
